module.exports = __webpack_public_path__ + "images/klinkerof-9f736d56b17a77fb7b64c5fb3444c3b4.jpg";